import { Boton, Divisor, PilaH } from '@/components/atomos';
import { manejarErrorAlerta } from '@/helpers/errores';
import { BANNER_HOME } from '@/helpers/urls';
import useComboEstados from '@/hooks/useComboEstados';
import { infoBannerAdapter } from '@/models/adapters/cliente.adapter';
import RespuestaApi from '@/models/respuestas/resApi.model';
import {
  InfoBannerHome,
  ResInfoBannerHome,
} from '@/models/respuestas/usuario.model';
import api from '@/providers/api';
import { estilosSecciones } from '@/styles/constants';
import { useBoolean, useMediaQuery } from '@chakra-ui/react';
import { useCallback, useEffect, useState } from 'react';
import InfoUltimaOperacionBannerHome from './InfoUltimaOperacionBannerHome';
import InfoEstadoCuenta from './InfoEstadoCuenta';
import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { FACTORING } from '@/routes/AppRoutes';
import CarruselAlertas from './Alertas/CarruselAlertas';

const estadoInicial: InfoBannerHome = {
  alertas: [],
  enrolado: false,
  operacion: {
    idEstado: 0,
    cantidadDocumentos: 0,
    estadoOperacion: '',
    idOperacion: 0,
    montoTotalOperacion: '',
    nroOperacion: 0,
  },
  perfil: {
    tieneCorreo: false,
    tieneDomicilio: false,
    tieneTelefono: false,
  },
};

const BannerResumenCliente = () => {
  useComboEstados();
  const [montado, setMontado] = useBoolean(false);
  const [cargando, setCargando] = useBoolean(false);
  const [infoCliente, setInfoCliente] = useState<InfoBannerHome>(estadoInicial);
  const [mobile] = useMediaQuery('(max-width: 768px)');

  const obtenerInfoBaner = useCallback(async () => {
    try {
      setCargando.on();
      const {
        data: { resultado },
      } = await api.get<RespuestaApi<ResInfoBannerHome>>(BANNER_HOME);
      setInfoCliente(infoBannerAdapter(resultado));
    } catch (error) {
      manejarErrorAlerta(
        error,
        'Hubo un error al obtener los datos del perfil'
      );
    } finally {
      setCargando.off();
    }
  }, [setCargando]);

  useEffect(() => {
    if (!montado) return setMontado.on();
    obtenerInfoBaner();
  }, [obtenerInfoBaner, montado, setMontado]);

  return (
    <PilaH
      w={'full'}
      py="3"
      px="5"
      justifyContent={'space-between'}
      flexWrap={"wrap"}
      {...estilosSecciones}
    >
      <PilaH gap='6'>
        <InfoUltimaOperacionBannerHome
          {...infoCliente.operacion}
          cargando={cargando}
        />
        {!mobile ? (
          <>
            
            <InfoEstadoCuenta
              cargando={cargando}
              enrolado={infoCliente.enrolado}
              perfil={infoCliente.perfil}
            />
            <Divisor orientation='vertical' h='130px' />
            <CarruselAlertas alertas={infoCliente.alertas} />
          </>
        ) : null}
      </PilaH>
      <Boton variant='action' size={'lg'} as={Link} to={FACTORING.OPERACIONES}>
        Todas las operaciones
        <ChevronRight size={16} />
      </Boton>
    </PilaH>
  );
};

export default BannerResumenCliente;
